//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { openDownloadDialog } from '@/utils/util';
export default {
  data() {
    return {
      userId: '',
      searchForm: {
        name: '',
        key: '',
        latest: 'true',
        app_id: '',
      },
      list: [],
      // 产品列表
      appList: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
    };
  },
  created() {
    try {
      const userInfo = JSON.parse(sessionStorage.getItem('userinfo-ams'));
      this.userId = userInfo.uin;
    } catch (err) {
      console.log(err);
    }
    this.getList();
    this.getAppList();
  },
  methods: {
    searchList() {
      this.pageIndex = 1;
      this.getList();
    },
    resetForm() {
      this.$refs.searchForm.resetFields();
      this.searchList();
    },
    async getList() {
      try {
        const { process_array: list, total = 0 } = await this.$request({
          url: this.$api.getListProcess,
          data: {
            user_id: this.userId,
            input_params: {
              start: `${(this.pageIndex - 1) * this.pageSize}`,
              size: `${this.pageSize}`,
              ...this.searchForm,
              key: this.searchForm.key || undefined,
              name: this.searchForm.name || undefined,
            },
          },
        });
        this.list = list;
        this.total = Number(total);
      } catch (err) {
        console.log(err);
      }
    },
    async createModel({ id }) {
      try {
        await this.$request({
          url: this.$api.generateProcessMaterial,
          data: { id },
        });
        this.$message({
          message: '操作成功',
          type: 'success',
        });
      } catch (err) {
        console.log(err);
      }
    },
    async derive(row) {
      const { id, process_name: processName, process_key: processKey, version } = row;
      try {
        const {
          material_json: json,
          name,
          module,
          edit_process_desc: desc = '',
          remark = '',
        } = await this.$request({
          url: this.$api.exportProcessMaterial,
          data: { id },
        });
        const data = {
          edit_json: json,
          edit_process_name: name,
          process_key: processKey,

          edit_process_desc: desc,
          module,
          remark,
        };

        const filename = `${processName || '导出'}${processName && version ? `(${version})` : ''}`;
        openDownloadDialog(
          new Blob([JSON.stringify(data)], { type: 'application/json' }),
          `${filename}.json`,
        );
      } catch (err) {
        console.log(err);
      }
    },
    del({ id }) {
      this.$confirm('确定删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          this.$request({
            url: this.$api.deleteProcess,
            data: { id },
            cb: () => {
              this.pageIndex = 1;
              this.getList();
            },
          });
        } catch (err) {
          console.log(err);
        }
      });
    },
    // 分页器
    handleSizeChange(value) {
      this.pageIndex = 1;
      this.pageSize = value;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
    // 获取产品列表
    getAppList() {
      const url = this.$api.getAppList;
      const data = { page_size: 999999 };
      const cb = (data) => {
        this.appList = data?.data?.map((item) => ({
          value: `${item.id}`,
          label: item.name,
        }));
      };
      this.$request({ url, data, cb, showLoding: false });
    },
    toViewLog(row) {
      this.$router.push({
        name: 'process-log',
        query: {
          row: JSON.stringify(row),
        },
      });
    },
  },
};
